import { createSlice } from "@reduxjs/toolkit";

// Define the initial state of the modal
const initialState = {
  isOpen: false,
  blockId: null,
  // Additional state properties can be added as needed
};

const moveBlockDialogSlice = createSlice({
  name: "moveBlockDialog",
  initialState,
  reducers: {
    openMoveBlockModal: (state, action) => {
      state.isOpen = true;
      state.blockId = action.payload.blockId;
    },
    closeMoveBlockModal: (state) => {
      state.isOpen = false;
      state.blockId = null;
    },
  },
});

export const { openMoveBlockModal, closeMoveBlockModal } =
  moveBlockDialogSlice.actions;

export default moveBlockDialogSlice.reducer;
